import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../client';
import { useTenant } from '../../hooks/useTenant';
import type { MetricsResponse, TimeRange } from '../types';
import { requireTenant } from './queryGuards';

const REFETCH_INTERVAL = 30 * 1000; // 30 seconds

export function useMetrics(timeRange: TimeRange = '24h') {
  const { tenantId } = useTenant();

  return useQuery<MetricsResponse>({
    queryKey: ['metrics', tenantId, timeRange],
    queryFn: () => {
      const requiredTenantId = requireTenant(tenantId);
      return apiClient.getMetrics({ tenant_id: requiredTenantId, time_range: timeRange });
    },
    enabled: !!tenantId,
    refetchInterval: REFETCH_INTERVAL,
    staleTime: 10 * 1000, // 10 seconds
  });
}
